import Permissions from './permissions.vue';

export default Permissions;
